/*
 * @Author: cn1994
 * @Date: 2023-12-13 10:54:48
 * @LastEditors: cn1994
 * @LastEditTime: 2024-08-16 14:46:02
 * @Description: 数据中心v2版本接口
 */
import request from '@/common/request.js'

// 获取数据概览页面数据
export const getQuickBIUrl = (params) => {
  // return request({
  //   url: 'OSS/index.php?g=DataCenter&m=index&a=getQuickBiUrl',
  //   method: 'get',
  //   params
  // })
  return request({
    url: 'BUSINESS/dataCenter/getQuickBiUrl',
    method: 'get',
    params
  })
}

// check quick bi的ticket
export const checkQuickBITicket = (params) => {
  return request({
    url: 'OSS/index.php?g=DataCenter&m=index&a=getTicketInfo',
    method: 'get',
    params
  })
}

export default {
  getQuickBIUrl,
  checkQuickBITicket
}